import $ from 'jquery';

(function(){
    let speakerSection = $('.event-speaker');
    let speakerElements = document.getElementsByClassName("speaker");
    if(speakerSection.find('.speaker').length > 4){
        showLess();
    }else{
        speakerSection.find('.seeMoreContainer').hide();
        speakerSection.find('.seeLessContainer').hide();
    }

    function showMore(){
        speakerSection.find('.seeMoreContainer')[0].style.display = 'none';
        speakerSection.find('.seeLessContainer')[0].style.display = 'flex';

        for(let x = 4; x < speakerElements.length; x++){
            speakerElements[x].style.display = 'flex';
        }
    }
    function showLess(){
        speakerSection.find('.seeMoreContainer')[0].style.display = 'flex';
        speakerSection.find('.seeLessContainer')[0].style.display = 'none';
        
        for(let x = 3; x < speakerElements.length; x++){
            speakerElements[x].style.display = 'none';
        }

    }

    speakerSection.on('click', '.seeMoreContainer', showMore)
    speakerSection.on('click', '.seeLessContainer', showLess)
})();